import { buildDefaultOrder, DefaultDirections, OrderBy, OrderDirection } from '@tableau/catalog-ui-temp';

import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

/**
 * Parses the order clause from the resource query and converts it to
 */
export function getSortOrderOrDefault<OrderFields extends string>(
  orderClauses: ReadonlyArray<IOrderClause<OrderFields>>,
  defaultField: OrderFields,
  defaultDirections: DefaultDirections<OrderFields>,
): OrderBy<OrderFields> {
  const orderBy = orderClausesToOrderBy(orderClauses);
  return orderBy || buildDefaultOrder(defaultField, defaultDirections);
}

/**
 * Converts an array of VPC order clauses to a DC3 OrderBy for graphql requests.
 * The resulting object's field/direction will be converted to all uppercase, per our graphql convention.
 *
 * If no primary order clause, returns null.
 */
export function orderClausesToOrderBy<OrderFields extends string>(
  orderClauses: ReadonlyArray<IOrderClause<OrderFields>>
): OrderBy<OrderFields> | null {

  const orderClause = orderClauses && orderClauses[0];
  return orderClause ? {
    field: orderClause.field.toUpperCase() as OrderFields,
    direction: orderClause.ascending ? OrderDirection.ASC : OrderDirection.DESC,
  } : null;
}

/**
 * Converts a DC3 OrderBy object to an array of VPC order clauses.
 * The resulting order clause's field will be converted to all lowercase, per VPC convention.
 */
export function orderByToOrderClauses(orderBy: OrderBy<string>): IOrderClause<string>[] {
  return [
    {
      field: orderBy.field.toLowerCase(),
      ascending: orderBy.direction === OrderDirection.ASC,
    }
  ];
}

/**
 * Converts a DC3 *OrderField object into an array of order keys for VizPortal,
 * to be used when specifying a content type's valid order keys.
 * Converts all the keys to lowercase, per VPC convention.
 */
export function getOrderKeysFromCatalogType<K extends string>(orderKeysObj: {[P in K]: unknown}): ReadonlyArray<string> {
  return Object.keys(orderKeysObj).map(k => k.toLowerCase());
}
